"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ArrowRightTraySolid: function() {
        return ArrowRightTraySolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ArrowRightTraySolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M5 2C3.34314 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H12C12.5523 22 13 21.5523 13 21V15.0014L7.99917 15C6.34231 14.9995 4.99954 13.656 5 11.9992C5.00046 10.3423 6.34398 8.99954 8.00083 9L13 9.00139V3C13 2.44772 12.5523 2 12 2H5Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289C15.9024 7.68342 15.9024 8.31658 16.2929 8.70711L18.5887 11.0029L8.00028 11C7.44799 10.9998 7.00015 11.4474 7 11.9997C6.99985 12.552 7.44744 12.9998 7.99972 13L18.5828 13.0029L16.2929 15.2929C15.9024 15.6834 15.9024 16.3166 16.2929 16.7071C16.6834 17.0976 17.3166 17.0976 17.7071 16.7071L21.6547 12.7595C21.8661 12.5763 21.9999 12.3057 22 12.0039V12.0027C22.0007 11.7458 21.903 11.4888 21.7071 11.2929L17.7071 7.29289Z",
            fill: "currentColor"
        })
    ]
}), "ArrowRightTraySolid");
const _default = ArrowRightTraySolid;
